import styled from '@emotion/styled'

const S = {}

S.Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  background-color: rgba(35, 37, 43, 0.5);
`

export default S
